import type { RootState } from 'store'

export const getHeader = (state: RootState) => state.header
